export const updateTableObjects = (params) => {
  const { tableObjects, otherCalculations, caseLists, cases, selectedTypes } =
    params;

  return tableObjects.map((obj) => {
    const empCalc = otherCalculations?.[caseLists]?.[obj?.id] || {};

    if (cases === "isThirdCase") {
      const {
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig,
        phicArr,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig,
        phic: phicArr,
        netPay: netAmount,
      };
    }
    //  else if (cases === "isSecondCase") {
    //   const { phic, pagibig, gsislr, earnedBasic, earnedPeraAda } = empCalc;
    //   return {
    //     ...obj,
    //     phic,
    //     pagibig,
    //     earnedBasic,
    //     earnedPeraAda,
    //     gsislr,
    //   };
    // }
    else if (cases === "isFourthCase") {
      const {
        proratedApRate,
        lateUtCurrentAss,
        earnedCurrAss,
        absencesLeaves_1,
        absencesLeaves_2,
        lateUtAirportAss,
        totalEarned,
        numberOfDuty,
        numberOfDuty2,
        overpayment,
        excessAirportDuty,
        airportDutyEarned,
        flagRaising,
        netEarned,
        tax,
        apRate,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        apRate,
        OfDutyForCiaMciaBinocRangeTo1519: numberOfDuty,
        OfDutyForCiaMciaBinocRangeTo15192: numberOfDuty2,
        proratedApRate,
        latesUt3: lateUtCurrentAss,
        earnedCurrentAssignment: earnedCurrAss,
        absencesLeaves: absencesLeaves_1,
        absencesLeaves2: absencesLeaves_2,
        latesUt4: lateUtAirportAss,
        earnedAirportDuties: airportDutyEarned,
        totalEarned,
        overpayment,
        totalDaysDuty: numberOfDuty,
        flagRaising,
        excessAirportDuty,
        netEarned,
        tax,
        netAmount,
      };
    } else if (cases === "isFifthCase") {
      const {
        absencesDays,
        absencesMins,
        earnedFoPeriod,
        overpayment,
        flagRaising,
        fivePercent,
        tenPercent,
        threePercent,
        twoPercent,
        totalTax,
        netPay,
      } = empCalc;

      return {
        ...obj,
        absencesDays,
        absencesMins,
        earnedForThePeriod: earnedFoPeriod,
        3: threePercent,
        2: twoPercent,
        5: fivePercent,
        10: tenPercent,
        totalTax,
        netPay,
        overpayment,
        flagRaising,
      };
    } else if (cases === "isSixthCase") {
      const {
        year,
        month,
        overpayment,
        flagRaising,
        noOfDays,
        basicRate,
        basicRateForBackPay,
        absencesMins,
        absencesDays,
        earnedForThePeriod,
        threePercent,
        twoPercent,
        fivePercent,
        tenPercent,
        totalTax,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        year,
        month,
        overpayment,
        flagRaising,
        basic: basicRate,
        basicRateForBackPay,
        earnedForThePeriod,
        3: threePercent,
        2: twoPercent,
        5: fivePercent,
        10: tenPercent,
        noOfDays,
        absencesMins,
        absencesDays,
        totalTax,
        netPay: netAmount,
      };
    } else if (cases === "isSeventhCase") {
      const { netPay, tax, pagibig, phic } = empCalc;

      if (selectedTypes?.payItems === "Last") {
        return {
          ...obj,
          netPay,
          tax,
          pagibig,
          // phic,
        };
      }

      return {
        ...obj,
        netPay,
        // phic,
        tax,
      };
    } else if (cases === "isEightCase") {
      const {
        dailyRate,
        perMinute,
        earnedForThePeriod,
        latesUtDeduction,
        netAmount,
        tax,
        overpayment,
        flagRaising,
        numberOfDuty,
        daysEarned,
        apRate,
      } = empCalc;
      return {
        ...obj,
        apRate,
        dailyRate,
        perMinute,
        overpayment,
        flagRaising,
        earnedForThePeriod,
        latesUtDeduction,
        OfDutyForCiaMciaBinocRangeTo1519: numberOfDuty,
        daysEarned,
        netPay: netAmount,
        tax,
      };
    } else if (cases === "isEleventhCase") {
      const {
        twoPercent,
        netAmount,
        numberOfDuty,
        proratedRate,
        gratuityPay,
        twentyPercent,
        totalEarned,
        threePercent,
        absMins,
        earned,
        salary: basicSalary,
      } = empCalc;

      return {
        ...obj,
        basicSalary,
        2: twoPercent,
        OfDutyForCiaMciaBinocRangeTo1519: numberOfDuty,
        gratuityPay,
        20: twentyPercent,
        proratedRate,
        totalEarned,
        earned,
        absMins,
        tax3: threePercent,
        netAmount,
      };
    } else if (cases === "isTwelvethCase") {
      const {
        apRate,
        ciaMciaBinoc,
        proratedApRate,
        apRateForBackPay,
        absenceLeavesCurAss,
        latesUtCurAss,
        earnedCurrAss,
        absencesLeavesAirport,
        lateUtAirportAss,
        airportDutyEarned,
        excessAirportDuties,
        totalDaysDuty,
        overpayment,
        flagRaising,
        netEarned,
        totalEarned,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        apRate,
        totalDaysDuty,
        proratedApRate,
        apRateForBackPay,
        absencesLeaves: absenceLeavesCurAss,
        latesUt3: latesUtCurAss,
        earnedCurrentAssignment: earnedCurrAss,
        absencesLeaves2: absencesLeavesAirport,
        latesUt4: lateUtAirportAss,
        earnedAirportDuties: airportDutyEarned,
        excessAirportDuties,
        overpayment,
        flagRaising,
        netEarned,
        totalEarned,
        netAmount,
      };
    } else if (cases === "isTenthCase") {
      const { myDiff, yeDiff, netPay, tax } = empCalc;
      return {
        ...obj,
        myDiff,
        yeDiff,
        netPay,
        tax,
      };
    } else if (
      selectedTypes.payrollTypes === "BP" &&
      selectedTypes.payItems === "Addendum Payroll"
    ) {
      const {
        earnedBasic,
        earnedPeraAda,
        netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        phic,
        pagibig,
        gsisLR,
      } = empCalc;

      const isZero = (val) => parseFloat(val) === 0;
      const shouldZeroOutDeductions =
        isZero(earnedBasic) && isZero(earnedPeraAda);

      return {
        ...obj,
        earnedBasic,
        earnedPeraAda,
        netPay: netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig: shouldZeroOutDeductions ? 0 : pagibig,
        phic: shouldZeroOutDeductions ? 0 : phic,
        gsisLR: shouldZeroOutDeductions ? 0 : gsisLR,
      };
    } else {
      const {
        earnedBasic,
        earnedPeraAda,
        netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
      } = empCalc;

      return {
        ...obj,
        earnedBasic,
        earnedPeraAda,
        netPay: netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
      };
    }
  });
};

export const updateTableObjects_1 = (params) => {
  const {
    tableObjects,
    noOfDuties,
    daysInMonth,
    periodCount,
    monthNames,
    cases,
    employees,
    processedAttendance,
  } = params;

  const firstItem = employees[0];

  return tableObjects.map((obj) => {
    if (obj.id !== firstItem?.id) return obj;
    const processedLogs = processedAttendance?.processedLogs?.[obj?.biometricId]?.regular;
    const processedLogsAirport = processedAttendance?.processedLogs?.[obj?.biometricId]?.airport;
    const lookupData = processedAttendance?.lookupData?.[obj?.biometricId];
    console.log("processedLogs++", processedLogs);
    console.log("lookupData++", lookupData);

    const daysInAMonth = daysInMonth[obj?.id];
    const updatedCountPrd = periodCount[obj?.id];
    const noOfDutiesInAirport = noOfDuties[obj?.id];
    const monthNamesArr = monthNames[obj?.id];

    const totalLateUTMins = processedLogs?.totalLateUTMins;
    const absentCount = processedLogs?.absentCount;
    const halfDayCount = processedLogs?.halfDayCount;
    const workingDaysSetArray = lookupData?.workingDaysSetArray;
    const workingDaysCount = lookupData?.workingDaysCount;
    const absentDates = processedLogs?.absentDates;
    const halfDayDates = processedLogs?.halfDayDates;
    const minutesIncurred = processedLogs?.minutesIncurred;
    const lateCount = processedLogs?.lateCount;
    const lateDates = processedLogs?.lateDates;
    const holidays = lookupData?.holidays;
    const suspensions = lookupData?.suspensions;
    const leaveWithoutPay = lookupData?.leaveWithoutPay;
    const leaveWithoutPaySetArray = lookupData?.leaveWithoutPaySetArray ? lookupData.leaveWithoutPaySetArray : [];

    console.log("leaveWithoutPay", leaveWithoutPay);

    if (cases === "isThirdCase") {
      return {
        ...obj,
        daysInAMonth,
        minutesToBeDeducted: totalLateUTMins,
        daysToBeDeducted: absentCount,
        halfDaysToBeDeducted: halfDayCount,
        leaveWithoutPay,
        updatedCountPrd,
        monthNamesArr,
        totalLateUTMins,
        absentCount,
        halfDayCount,
        workingDaysSetArray,
        workingDaysCount,
        absentDates,
        halfDayDates

      };
    }

    if (cases === "isSixthCase") {
      return {
        ...obj,
        daysToBeDeducted: absentCount,
        minsToBeDeducted: totalLateUTMins,
        updatedCountPrd,
        monthNamesArr,
        minutesIncurred,
        lateCount,
        lateDates,
        absentDates
      };
    }
    if (cases === "isEightCase") {
      return {
        ...obj,
        daysToBeDeducted: absentCount,
        minsToBeDeducted: totalLateUTMins,
        workingDaysSetArray,
        leaveWithoutPay,
        workingDaysCount,
        updatedCountPrd,
        monthNamesArr,
        lateDates,
        minutesIncurred,
        lateCount,
        holidays,
        suspensions,
      };
    }
    if (cases === "isEleventhCase") {
      return {
        ...obj,
        daysToBeDeducted: absentCount,
        minsToBeDeducted: totalLateUTMins,
        workingDaysCount,
        updatedCountPrd,
        monthNamesArr,
        minutesIncurred,
        holidays, 
        suspensions,
      };
    }
    if (cases === "isTwelvethCase") {
      const combineCount = (absentCount ?? []).map(
        (count, idx) => (count ?? 0) + (leaveWithoutPaySetArray[idx]?.size ?? 0)
      );
      return {
        ...obj,
        abs: combineCount,
        latesUt: totalLateUTMins,
        abs2: processedLogsAirport?.absentCount,
        latesUt2: processedLogsAirport?.totalLateUTMins,
        noOfDuties: noOfDutiesInAirport,
        workingDaysSetArray,
        leaveWithoutPaySetArray,
        workingDaysCount,
        minutesIncurred,
        absentDates,
        lateDates,
        absentDatesAirport: processedLogsAirport?.absentDates,
        updatedCountPrd,
        monthNamesArr,
        lateCount,
        lateDates
      };
    }

    return {
      ...obj,
      daysInAMonth,
      minutesToBeDeducted: totalLateUTMins,
      daysToBeDeducted: absentCount,
      halfDaysToBeDeducted: halfDayCount,
      updatedCountPrd,
      monthNamesArr,
    };
  });
};

export const updateTableObjects_2 = (params) => {
  const { updatedTableObj, otherCalculations, caseLists, cases } = params;

  return updatedTableObj.map((obj) => {
    const empCalc = otherCalculations?.[caseLists]?.[obj?.id] || {};

    if (cases === "isThirdCase") {
      const {
        salary,
        deductionsDueToLeavesAbsencesAndTardinessBasic,
        deductionPeraAda,
        peraDeducts,
        earnedBasic,
        datesOfAbsence,
        datesOfHalfday,
        earnedPeraAda,
        gsisInsuredDays,
        basicRateForBackPay,
        peraAdaForBackPay,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        basic: salary,
        gsisInsuredDays,
        basicRateForBackPay,
        peraAdaForBackPay,
        deductionsDueToLeavesAbsencesAndTardinessBasic,
        deductionPeraAda,
        datesOfAbsence,
        datesOfHalfDay: datesOfHalfday,
        earnedBasic,
        earnedPeraAda,
        netPay: netAmount,
      };
    } else if (cases === "isSixthCase") {
      const {
        basicRateForBackPay,
        netAmount,
     flagRaising,
        noOfDays,
        absencesDays,
        absencesMins,
        earnedForThePeriod,
        datesOfAbsence,
        datesOfFlagRaising,
        basicRate
      } = empCalc;

      return {
        ...obj,
        basicRateForBackPay,
        basic: basicRate,
        noOfDays,
      flagRaising,
        absencesDays,
        absencesMins,
        datesOfAbsence,
        datesOfFlagRaising,
        earnedForThePeriod,
        netPay: netAmount,
      };
    } else if (cases === "isEightCase") {
      const { netAmount, daysEarned, totalLatesUt, latesUtDeduction, flagRaising, datesOfFlagRaising} = empCalc;

      return {
        ...obj,
        flagRaising,
        datesOfFlagRaising,
        daysEarned,
        latesUtDeduction,
        noOfLatesIncurred: totalLatesUt,
        netPay: netAmount,
      };
    } else if (cases === "isEleventhCase") {
      const {
        netAmount,
        inService,
        proratedRate,
        minsToBeDeduc,
        absMins,
        earned,
        twentyPercent,
        totalEarned,
        threePercent,
        salary: basicSalary,
      } = empCalc;
      return {
        ...obj,
        basicSalary,
        netPay: netAmount,
        noOfDaysPresent: inService,
        proratedRate,
        minsDeducted: minsToBeDeduc,
        absMins,
        earned,
        20: twentyPercent,
        totalEarned,
        tax3: threePercent,
        netAmount,
      };
    } else if (cases === "isTwelvethCase") {
      const { apRateForBackPay, flagRaising, datesOfAbsence, datesOfAbsenceAirport, ciaMciaBinoc, ciaMciaBinoc2, totalDaysDuty } = empCalc;
      return {
        ...obj,
        OfDutyForCiaMciaBinocRangeTo1519: ciaMciaBinoc,
        totalDaysDuty,
        OfDutyForCiaMciaBinocRangeTo15192: ciaMciaBinoc2,
        apRateForBackPay,
        dateOfAbsencesLeave: datesOfAbsence,
        augmentationDateOfAbsences: datesOfAbsenceAirport,
        flagRaising,
      };
    }
  });
};

export const updateTableObjects_3 = (params) => {
  const { modifiedTable, otherCalculations, caseLists, cases } = params;

  return modifiedTable.map((obj) => {
    const empCalc = otherCalculations?.[caseLists]?.[obj?.id] || {};
    const matchedCsvRow = empCalc?.matchedCsvRow;
    const uploadedCsvRow = empCalc?.uploadedCsvRow;
    const cleanedObj = { ...obj };

    if (matchedCsvRow === "restore" && uploadedCsvRow) {
      Object.assign(cleanedObj, uploadedCsvRow);
    } else if (matchedCsvRow) {
      Object.keys(matchedCsvRow).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(cleanedObj, key)) {
          delete cleanedObj[key];
        }
      });
    }

    if (cases === "isThirdCase") {
      const { netAmount , gsis} = empCalc;
      return {
        ...cleanedObj,
        netPay: netAmount,
        gsisLR: gsis,
      };
    } else if (cases === "isSixthCase") {
      const { netAmount, absencesDays, earnedForThePeriod, absencesMins, noOfDays , year, month, basicRateForBackPay, flagRaising} = empCalc;

      return {
        ...cleanedObj,
        // basic: basicRate,
        // flagRaising,
        basicRateForBackPay,
        year,
        month,
        earnedForThePeriod,
        absencesMins,
        noOfDays,
        netPay: netAmount,
        absencesDays,
      };
    } else if (cases === "isEightCase") {
      const { netAmount, latesUtDeduction, earnedForThePeriod } = empCalc;
      return {
        ...cleanedObj,
        earnedForThePeriod,
        latesUtDeduction,
        netPay: netAmount,
      };
    } else if (cases === "isEleventhCase") {
      const { netAmount, proratedRate } = empCalc;
      return {
        ...cleanedObj,
        proratedRate,
        netPay: netAmount,
      };
    } else if (cases === "isTwelvethCase") {
      const {
        year,
        month,
        proratedApRate,
        apRateForBackPay,
        absenceLeavesCurAss,
        datesOfFlagRaising,
        latesUtCurAss,
        earnedCurrAss,
        airportAugmentationRate,
        airportAugAmt,
        ciaMciaBinoc,
        ciaMciaBinoc2,
        absencesLeavesAirport,
        lateUtAirportAss,
        airportDutyEarned,
        netEarned,
        totalEarned,
        netAmount,
      } = empCalc;

      return {
        ...cleanedObj,
        year,
        month,
        proratedApRate,
        apRateForBackPay,
        OfDutyForCiaMciaBinocRangeTo1519: ciaMciaBinoc,
        OfDutyForCiaMciaBinocRangeTo15192: ciaMciaBinoc2,
        absencesLeaves: absenceLeavesCurAss,
        latesUt3: latesUtCurAss,
        earnedCurrentAssignment: earnedCurrAss,
        airportAugmentationRate,
        amountEarnedAirportAugmentation: airportAugAmt,
        absencesLeaves2: absencesLeavesAirport,
        datesOfFlagRaising,
        latesUt4: lateUtAirportAss,
        earnedAirportDuties: airportDutyEarned,
        netEarned,
        totalEarned,
        netAmount,
      };
    }
  });
};
